"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var LanguagePipe = /** @class */ (function () {
    function LanguagePipe() {
    }
    LanguagePipe.prototype.transform = function (value, language) {
        if (typeof value !== 'string') {
            console.error("LanguagePipe has been invoked with an invalid value type [" + value + "]");
            return value;
        }
        if (typeof language !== 'string') {
            console.error("LanguagePipe has been invoked with an invalid parameter [" + language + "]");
            return value;
        }
        return '```' + language + '\n' + value + '\n```';
    };
    LanguagePipe.decorators = [
        { type: core_1.Pipe, args: [{
                    name: 'language',
                },] },
    ];
    return LanguagePipe;
}());
exports.LanguagePipe = LanguagePipe;
//# sourceMappingURL=language.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-markdown/dist/lib/language.pipe.js
// module id = ./node_modules/ngx-markdown/dist/lib/language.pipe.js
// module chunks = vendor